"use strict";

import { addEvent } from "./addEvent/addEvent";
import { loadingStart, loadingEnd } from "./loading/loading";

loadingStart();

addEvent(window, "load", function () {
  afterLoadStart();
});

function afterLoadStart() {
  loadingEnd();
}
